<template>
  <div class="contactUs">
    <header-mod :page-name="'contactUs'"></header-mod>

    <div class="page">
      <div class="page_title">联系我们</div>
      <div class="company_name">怡信未来科技有限公司</div>
      <div class="contact_box">
        <div class="contact_msg">
          <div class="tit">怡亚数科总部</div>
          <div class="content">
            <p> <span>地址：</span> 深圳市南山区深圳湾科技生态园7栋B座(西区)901室 </p>
            <p> <span>电话：</span> 0755-33013550（工作日9:00-18:00） </p>
            <p> <span>邮编：</span> 518000 </p>
          </div>
        </div>

        <div class="contact_map">
          <img src="../assets/imgs/map.png" alt="">
        </div>
      </div>
    </div>

    <footer-mod></footer-mod>
  </div>
</template>

<script>
import headerMod from "@/components/header"
import footerMod from "@/components/footer"
export default {
  components: {
    HeaderMod: headerMod,
    FooterMod: footerMod
  },
  data() {
    return {

    }
  },
  methods: {

  },
  created() {
    document.title = '联系我们 - 怡信未来科技'
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/contactUs.vue